import styled from "styled-components";

export const TruckFormModalStyle = styled.div`

`;
